module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"previewQRs":"See QR Codes.","noPreviewQRs":"No QRs available to preview.","downloadQRs":"Download QR Codes.","noDownloadQRs":"No QRs available to download."},"es":{"previewQRs":"Visualizar códigos QR.","downloadQRs":"Descargar códigos QR.","noPreviewQRs":"No hay QRs disponibles para visualizar","noDownloadQRs":"No hay QRs disponibles para descargar"}}')
  delete Component.options._Ctor
}
